import { getComponentFromName } from '../../lib/utils';

import { useTheme } from '../../contexts/ContestContext';
import * as EndComponents from './gameEnds';

interface GameEndProps {
    game: Game;
    participation: Participation | null;
    isValid: boolean;
    reload: () => void;
    blocks?: Block[];
    children?: React.ReactNode;
}

function GameEnd({ game, ...props }: GameEndProps) {
    const { name: theme } = useTheme();
    const { theme: gameTheme } = game || {};
    const { endComponent = null } = gameTheme || {};
    const EndComponent =
        getComponentFromName(EndComponents, endComponent, null) ||
        getComponentFromName(EndComponents, theme, 'default');

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <EndComponent game={game} {...props} />;
}

export default GameEnd;
